module.exports = __webpack_public_path__ + "img/smartphone_locked-512.1f509bb7.png";